export const Messages = {
  EMAIL_REQUIRED: 'Please enter your email address.',
  HEADLINE_REQUIRED: 'Headline is required',
  EVENT_NAME_REQUIRED: 'Event name is required',
  VOUCHER_TITLE_REQUIRED: 'Voucher Title is required',
  DESCRIPTION_REQUIRED: 'Description is required',
  DESCRIPTION_MAX_LENGTH: 'Maximum Length should be 300',
  LOCATION_REQUIRED: 'Location is required',
  CONTACT_NUMBER_REQUIRED: 'Contact Number is required',
  CONTACT_NUMBER_VALID:
    'Please enter a valid number containing 10-digit mobile number',
    CONTACT_NUMBER_VALID_LANDLINE:'Please enter a valid number containing a minimum of 10 digits and a maximum of 15 digits',
  MALL_REQUIRED: 'Mall is required',
  COVER_IMAGE_REQUIRED: 'Cover Image is required',
  START_DATE_REQUIRED: 'Start Date is required',
  END_DATE_REQUIRED: 'End Date is required',
  START_TIME_REQUIRED: 'Start time is required',
  END_TIME_REQUIRED: 'End time is required',
  MALL_NAME_REQUIRED: 'Mall Name is required',
  BANNER_TYPE_REQUIRED: 'Banner Type is required',
  IMAGE_VIDEO_REQUIRED: 'Image/Video is required',
  ADDRESS_REQUIRED: 'Address is required',
  OPENING_TIME_REQUIRED: 'Opening time is required',
  CLOSING_TIME_REQUIRED: 'Closing time is required',
  LOGO_IMAGE_REQUIRED: 'Logo Image is required',
  AMENITIES_REQUIRED: 'Amenities is required',
  STORE_NAME_REQUIRED: 'Store Name is required',
  CATEGORY_REQUIRED: 'Category is required',
  SUB_CATEGORY_REQUIRED: 'Sub Category is required',
  PART_OF_REWARD_REQUIRED: 'Part of Reward status is required',
  INVALID_PHONE_NUMBER: 'Invalid Phone Number',
  EMAIL_INVALID: 'Email is invalid',
  CITY_REQUIRED: 'City is required',
  STOTE_TYPE: 'Store Type is required',
  TIER_MASTER_REQUIRED: 'Tier Master is required',
  TEMPLATE_REQUIRED: 'Template is required',
  TIER_MIN_RANGE_REQUIRED: 'Min Range is required',
  TIER_MAX_RANGE_REQUIRED: 'Max Range is required',
  TIER_NAME_REQUIRED: 'Tier Name is required',
  DISCOUNT_REQUIRED: 'Discount is required',
  VOUCHER_NAME_REQUIRED: 'Voucher Name is required',

  USAGE_LIMIT: 'Usage Limit is required',
  LOYALTY_POINTS: 'Loyalty Points is required',
  LOYALTY_POINTS_POSITIVE:
    'Loyalty Points must be greater than 0 for regular voucher',
  ALL_TIER_REGULAR_ONLY:
    'The "All" tier can be selected for regular vouchers only.',
  // Quick task 260903-fdd (D-5): same sentence as the server's own
  // rejection, so an admin who somehow bypasses this client-side guard sees
  // no wording change.
  SPECIAL_AND_GAME_EXCLUSIVE:
    'A voucher cannot be both a Special Voucher and reserved for a game.',
  PROMOTIONAL_IMAGE: 'Promotional Image is required',
  VISIBLE: true,
  FREQUENCY: 'Frequency is required',
  TERMS_OF_USAGE: 'Terms of Usage is required',
  VOUCHER_COUNT: 'Voucher Count is required',
  VOUCHER_TYPE: 'Voucher Type is required',
  VOUCHER_CODE: 'Voucher Code is required',
  STATUS: true,
  HOW_TO_REDEEM: 'How to Redeem is required',
  TITLE_REQUIRED: 'Title is required',
  SHOPPING_AMOUNT_REQUIRED: 'Shopping Amount is required',
  INVOICE_DATE: 'Invoice Date is required',
  INVOICE_NUMBER: 'Invoice number is required',
  ROLE_REQUIRED: 'Role is required',
  ALPHABET_SPACE: 'Only alphabets and spaces are allowed',
  FEEDBACK_NAME_REQUIRED: 'Feedback Name is required',
  FEEDBACK_IMAGE_REQUIRED: 'Feedback Image is required',
  URL_REQUIRED: 'URL is required',
  INVALID_URL: 'Invalid URL',
  GENDER_REQUIRED_MESSAGE: 'Gender is Required.',
  LINK_REQUIRED_MESSAGE: 'Link is Required.',
  USERTYPE_REQUIRED_MESSAGE: 'User Type is Required.',
  NOTIFICATION_TYPE_REQUIRED_MESSAGE: 'Notification Type is Required.',

  // Voucher packages. Every limit below mirrors VoucherPackageValidation.ts
  // on the server; the admin's axios interceptor drops class-validator detail,
  // so these client messages are the only field-level feedback.
  PACKAGE_TITLE_REQUIRED: 'Bundle Title is required',
  PACKAGE_TITLE_MAX_LENGTH: 'Bundle Title must be 150 characters or fewer',
  PACKAGE_DESCRIPTION_MAX_LENGTH: 'Description must be 2000 characters or fewer',
  PACKAGE_COUNT_REQUIRED: 'Bundle Count is required',
  PACKAGE_COUNT_MIN: 'Bundle Count must be a whole number of at least 1',
  PACKAGE_USAGE_LIMIT_MIN: 'Usage Limit must be a whole number of at least 1',
  PACKAGE_FREQUENCY_MIN: 'Frequency must be a whole number of at least 1',
  PACKAGE_SORT_ORDER_INVALID: 'Sort Order must be a whole number, 0 or greater',
  PACKAGE_END_BEFORE_START: 'Start date must not be after the expiry date',
  EXPIRY_DATE_REQUIRED: 'Expiry Date is required',
  PACKAGE_VOUCHER_TITLE_MAX_LENGTH:
    'Voucher Title must be 255 characters or fewer',
  PACKAGE_VOUCHER_POINTS_MIN:
    'Loyalty Points must be a whole number greater than 0',
};

export const bannerValidationRules = {
  mall_id: [{ type: 'required', message: Messages.MALL_NAME_REQUIRED }],
  img_type: [{ type: 'required', message: Messages.BANNER_TYPE_REQUIRED }],
  img_url: [{ type: 'required', message: Messages.IMAGE_VIDEO_REQUIRED }],
  // Optional link URL (BL-09/D-14/D-15). UX-only mirror of the server's
  // authoritative http(s)-only, <=2048-char check in bannerUrl.ts — the
  // server always wins on disagreement. `optionalPattern` skips this rule
  // entirely for an empty value, so clearing the field is never blocked.
  url: [
    {
      type: 'optionalPattern',
      value: /^https?:\/\/\S+$/i,
      message: 'Only http(s) links are allowed',
    },
    {
      type: 'maxLength',
      value: 2048,
      message: 'URL must be 2048 characters or fewer',
    },
  ],
};

export const mallValidationRules = {
  mallName: [{ type: 'required', message: Messages.MALL_NAME_REQUIRED }],
  description: [{ type: 'required', message: Messages.DESCRIPTION_REQUIRED }],
  location: [{ type: 'required', message: Messages.LOCATION_REQUIRED }],
  city: [{ type: 'required', message: Messages.CITY_REQUIRED }],
  address: [{ type: 'required', message: Messages.ADDRESS_REQUIRED }],
  contact_number: [
      {
      type: 'pattern',
      value: /^0?[0-9]{10,15}$/,
      message: Messages.CONTACT_NUMBER_VALID_LANDLINE,
    },
  ],

  closing_time: [{ type: 'required', message: Messages.CLOSING_TIME_REQUIRED }],
  opening_time: [
    { type: 'required', message: Messages.OPENING_TIME_REQUIRED },
    {
      type: 'timeNotGreaterThan',
      startTimeField: 'opening_time',
      endTimeField: 'closing_time',
      message: 'Opening time must not be greater than closing time',
    },
  ],
  logo: [{ type: 'required', message: Messages.LOGO_IMAGE_REQUIRED }],
};

export const supportServiceValidationRules = {
  mallId: [{ type: 'required', message: Messages.MALL_NAME_REQUIRED }],
  serviceId: [{ type: 'required', message: Messages.AMENITIES_REQUIRED }],
  contactNumber: [
    { type: 'required', message: Messages.CONTACT_NUMBER_REQUIRED },
    {
      type: 'pattern',
      value: /^[0-9]{10}$/,
      message: 'Length should be 10',
    },
  ],
};
export const notificationValidationRules = {
  mall_id_temp: [{ type: 'required', message: Messages.MALL_NAME_REQUIRED }],
  tierId: [{ type: 'required', message: Messages.TIER_MASTER_REQUIRED }],
  name: [{ type: 'required', message: Messages.NAME_REQUIRED }],
  title: [{ type: 'required', message: Messages.TITLE_REQUIRED }],
  message: [{ type: 'required', message: Messages.DESCRIPTION }],
  gender_type: [
    { type: 'required', message: Messages.GENDER_REQUIRED_MESSAGE },
  ],
  link: [
    { type: 'required', message: Messages.LINK_REQUIRED_MESSAGE },

    {
      type: 'optionalPattern',
      value:
        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/,
      message: Messages.INVALID_URL,
    },
  ],
  user_type: [
    { type: 'required', message: Messages.USERTYPE_REQUIRED_MESSAGE },
  ],
  notification_type: [
    { type: 'required', message: Messages.NOTIFICATION_TYPE_REQUIRED_MESSAGE },
  ],
};
export const defaulttierValidationRules = {
  mallId: [{ type: 'required', message: Messages.MALL_NAME_REQUIRED }],
  tierId: [{ type: 'required', message: Messages.TIER_MASTER_REQUIRED }],
  minRange: [{ type: 'required', message: Messages.TIER_MIN_RANGE_REQUIRED }],
  maxRange: [
    { type: 'required', message: Messages.TIER_MAX_RANGE_REQUIRED },
    {
      type: 'rangeComparison',
      minField: 'minRange',
      maxField: 'maxRange',
      message: 'Max range must be greater than min range',
    },
  ],
  priority: [{ type: 'required', message: 'Priority is required' }],
  discount: [
    { type: 'required', message: Messages.DISCOUNT_REQUIRED },

    {
      type: 'pattern',
      value: /^(100|[1-9]?[0-9](\.\d{1,3})?)$/,
      message: 'Discount should be between 1 to 100',
    },
  ],
};

export const festivetierValidationRules = {
  mallId: [{ type: 'required', message: Messages.MALL_NAME_REQUIRED }],
  parent: [{ type: 'required', message: 'Default Tier is Required' }],

  name: [{ type: 'required', message: Messages.TIER_NAME_REQUIRED }],
  startDate: [
    { type: 'required', message: Messages.START_DATE_REQUIRED },

    {
      type: 'dateNotGreaterThan',
      startDateField: 'startDate',
      endDateField: 'endDate',
      message: 'Start date must not be greater than end date',
    },
  ],
  endDate: [{ type: 'required', message: Messages.END_DATE_REQUIRED }],
  discount: [
    { type: 'required', message: Messages.DISCOUNT_REQUIRED },

    {
      type: 'pattern',
      value: /^(100|[1-9]?[0-9](\.\d{1,3})?)$/,
      message: 'Discount should be between 1 to 100',
    },
  ],
};

export const storeValidationRules = {
  storeName: [{ type: 'required', message: Messages.STORE_NAME_REQUIRED }],
  description: [{ type: 'required', message: Messages.DESCRIPTION_REQUIRED }],
  location: [{ type: 'required', message: Messages.LOCATION_REQUIRED }],
  type: [{ type: 'required', message: Messages.STOTE_TYPE }],
  contactNumber: [
    {
      type: 'pattern',
      value: /^0?[0-9]{10,15}$/,
      message: Messages.CONTACT_NUMBER_VALID_LANDLINE,
    },
  ],
  mallId: [{ type: 'required', message: Messages.MALL_NAME_REQUIRED }],
  categoryId: [{ type: 'required', message: Messages.CATEGORY_REQUIRED }],
  subCategoryId: [
    { type: 'required', message: Messages.SUB_CATEGORY_REQUIRED },
  ],
  partOfReward: [
    { type: 'required', message: Messages.PART_OF_REWARD_REQUIRED },
  ],
  managerPhoneNumber: [
    {
      type: 'optionalPattern',
      value: /^[0-9]{10}$/,
      message: Messages.CONTACT_NUMBER_VALID,
    },
  ],
  coverImage: [{ type: 'required', message: Messages.COVER_IMAGE_REQUIRED }],

  storeOpeningTime: [
    { type: 'required', message: Messages.OPENING_TIME_REQUIRED },
    {
      type: 'timeNotGreaterThan',
      startTimeField: 'storeOpeningTime',
      endTimeField: 'storeClosingTime',
      message: 'Opening time must not be greater than closing time',
    },
  ],
  storeClosingTime: [
    { type: 'required', message: Messages.CLOSING_TIME_REQUIRED },
  ],
  logo: [{ type: 'required', message: Messages.LOGO_IMAGE_REQUIRED }],
  managerEmail: [
    {
      type: 'optionalPattern',
      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: Messages.EMAIL_INVALID,
    },
  ],
  isCdit: [{ type: 'required', message: 'CDIT Status is required' }],
};

export const voucherValidationRules = {
  mallId: [{ type: 'required', message: Messages.MALL_NAME_REQUIRED }],
  storeId: [{ type: 'required', message: Messages.STORE_NAME_REQUIRED }],
  tierIds: [{ type: 'required', message: Messages.TIER_MASTER_REQUIRED }],
  startDate: [
    { type: 'required', message: Messages.START_DATE_REQUIRED },
    {
      type: 'dateNotGreaterThan',
      startDateField: 'startDate',
      endDateField: 'endDate',
      message: 'Start date must not be greater than end date',
    },
  ],
  endDate: [{ type: 'required', message: Messages.END_DATE_REQUIRED }],
  voucherTitle: [
    { type: 'required', message: Messages.VOUCHER_TITLE_REQUIRED },
  ],
  description: [{ type: 'required', message: Messages.DESCRIPTION_REQUIRED }],
  // categoryId: [{ type: 'required', message: Messages.CATEGORY_REQUIRED }],
  // subCategoryId: [
  //   { type: 'required', message: Messages.SUB_CATEGORY_REQUIRED },
  // ],
  usageLimit: [{ type: 'required', message: Messages.USAGE_LIMIT_REQUIRED }], // Added missing validation rule

  loyaltyPoints: [
    { type: 'requiredAllowZero', message: Messages.LOYALTY_POINTS },
  ],
  // promotionalImage: [
  //   { type: 'required', message: Messages.PROMOTIONAL_IMAGE_REQUIRED },
  // ],
  // logoImage: [{ type: 'required', message: Messages.LOGO_IMAGE_REQUIRED }],
  frequency: [{ type: 'required', message: Messages.FREQUENCY_REQUIRED }],
  termsOfUsage: [
    { type: 'required', message: Messages.TERMS_OF_USAGE_REQUIRED },
  ],
  voucherCount: [
    { type: 'required', message: Messages.VOUCHER_COUNT_REQUIRED },
  ],
  voucherType: [{ type: 'required', message: Messages.VOUCHER_TYPE_REQUIRED }],

  howToRedeem: [{ type: 'required', message: Messages.HOW_TO_REDEEM_REQUIRED }],
};

// Digits only, value of one or more. The form holds these fields as strings
// (to avoid parseInt('') -> NaN -> null in the payload), and the string '0' is
// truthy, so `required` alone would let it through.
const POSITIVE_WHOLE_NUMBER = /^[1-9]\d*$/;

export const packageValidationRules = {
  mallId: [{ type: 'required', message: Messages.MALL_NAME_REQUIRED }],
  title: [
    { type: 'required', message: Messages.PACKAGE_TITLE_REQUIRED },
    { type: 'maxLength', value: 150, message: Messages.PACKAGE_TITLE_MAX_LENGTH },
  ],
  description: [
    { type: 'required', message: Messages.DESCRIPTION_REQUIRED },
    {
      type: 'maxLength',
      value: 2000,
      message: Messages.PACKAGE_DESCRIPTION_MAX_LENGTH,
    },
  ],
  // The form holds 'ALL' for "All tiers" (submitted as []), so a non-empty
  // selection is always present when the admin has made a choice.
  tierIds: [{ type: 'required', message: Messages.TIER_MASTER_REQUIRED }],
  packageCount: [
    { type: 'required', message: Messages.PACKAGE_COUNT_REQUIRED },
    {
      type: 'pattern',
      value: POSITIVE_WHOLE_NUMBER,
      message: Messages.PACKAGE_COUNT_MIN,
    },
  ],
  usageLimit: [
    { type: 'required', message: Messages.USAGE_LIMIT },
    {
      type: 'pattern',
      value: POSITIVE_WHOLE_NUMBER,
      message: Messages.PACKAGE_USAGE_LIMIT_MIN,
    },
  ],
  // P2 D-15: a frequency of 0 is refused. The server wants a string of digits.
  frequency: [
    { type: 'required', message: Messages.FREQUENCY },
    {
      type: 'pattern',
      value: POSITIVE_WHOLE_NUMBER,
      message: Messages.PACKAGE_FREQUENCY_MIN,
    },
  ],
  // Optional: never required; blank is fine, otherwise a whole number >= 0.
  sortOrder: [
    {
      type: 'optionalPattern',
      value: /^\d+$/,
      message: Messages.PACKAGE_SORT_ORDER_INVALID,
    },
  ],
  termsOfUsage: [
    { type: 'required', message: Messages.TERMS_OF_USAGE },
  ],
  howToRedeem: [{ type: 'required', message: Messages.HOW_TO_REDEEM }],
  // No bundle dates: each voucher has its own, and the server derives the
  // bundle's (last voucher start, first voucher expiry).
};

// The create-package side panel's fields. The image is optional, like a
// regular voucher's. Each voucher carries its own start and expiry date.
// `sortOrder` is not part of a member voucher.
export const packageVoucherValidationRules = {
  storeId: [{ type: 'required', message: Messages.STORE_NAME_REQUIRED }],
  voucherTitle: [
    { type: 'required', message: Messages.VOUCHER_TITLE_REQUIRED },
    {
      type: 'maxLength',
      value: 255,
      message: Messages.PACKAGE_VOUCHER_TITLE_MAX_LENGTH,
    },
  ],
  description: [
    { type: 'required', message: Messages.DESCRIPTION_REQUIRED },
    {
      type: 'maxLength',
      value: 2000,
      message: Messages.PACKAGE_DESCRIPTION_MAX_LENGTH,
    },
  ],
  loyaltyPoints: [
    { type: 'required', message: Messages.LOYALTY_POINTS },
    {
      type: 'pattern',
      value: POSITIVE_WHOLE_NUMBER,
      message: Messages.PACKAGE_VOUCHER_POINTS_MIN,
    },
  ],
  startDate: [
    { type: 'required', message: Messages.START_DATE_REQUIRED },
    {
      type: 'dateNotGreaterThan',
      startDateField: 'startDate',
      endDateField: 'expiryDate',
      message: Messages.PACKAGE_END_BEFORE_START,
    },
  ],
  expiryDate: [{ type: 'required', message: Messages.EXPIRY_DATE_REQUIRED }],
};

export const offerValidationRules = {
  mallId: [{ type: 'required', message: Messages.MALL_NAME_REQUIRED }],
  storeId: [{ type: 'required', message: Messages.STORE_NAME_REQUIRED }],
  templateId: [{ type: 'required', message: Messages.TEMPLATE_REQUIRED }],
  startDate: [
    { type: 'required', message: Messages.START_DATE_REQUIRED },
    {
      type: 'dateNotGreaterThan',
      startDateField: 'startDate',
      endDateField: 'endDate',
      message: 'Start date must not be greater than end date',
    },
  ],
  endDate: [{ type: 'required', message: Messages.END_DATE_REQUIRED }],
  title: [{ type: 'required', message: Messages.TITLE_REQUIRED }],
  description: [{ type: 'required', message: Messages.DESCRIPTION_REQUIRED }],
};
export const eventValidationRules = {
  headline: [{ type: 'required', message: Messages.HEADLINE_REQUIRED }],
  name: [{ type: 'required', message: Messages.EVENT_NAME_REQUIRED }],
  description: [{ type: 'required', message: Messages.DESCRIPTION_REQUIRED }],
  locationDetails: [{ type: 'required', message: Messages.LOCATION_REQUIRED }],
  phone: [
    { type: 'required', message: Messages.CONTACT_NUMBER_REQUIRED },
    {
      type: 'pattern',
      value: /^[0-9]{10}$/,
      message: Messages.CONTACT_NUMBER_VALID,
    },
  ],
  mall_Id: [{ type: 'required', message: Messages.MALL_REQUIRED }],
  coverImage: [{ type: 'required', message: Messages.COVER_IMAGE_REQUIRED }],
  startDate: [
    { type: 'required', message: Messages.START_DATE_REQUIRED },

    {
      type: 'dateNotGreaterThan',
      startDateField: 'startDate',
      endDateField: 'endDate',
      message: 'Start date must not be greater than end date',
    },
  ],
  endDate: [{ type: 'required', message: Messages.END_DATE_REQUIRED }],

  eventOpeningTime: [
    { type: 'required', message: 'Opening time is required' },
    {
      type: 'timeNotGreaterThan',
      startTimeField: 'eventOpeningTime',
      endTimeField: 'eventClosingTime',
      message: 'Opening time must not be greater than closing time',
    },
  ],
  eventClosingTime: [{ type: 'required', message: 'Closing time is required' }],
};

export const billValidationRules = {
  phone_number: [
    { type: 'required', message: Messages.CONTACT_NUMBER_REQUIRED },
    {
      type: 'pattern',
      value: /^[0-9]{10}$/,
      message: Messages.CONTACT_NUMBER_VALID,
    },
  ],
  invoice_number: [{ type: 'required', message: Messages.INVOICE_NUMBER }],
  shopping_amount: [
    { type: 'required', message: Messages.SHOPPING_AMOUNT_REQUIRED },
  ],
  mallId: [{ type: 'required', message: Messages.MALL_REQUIRED }],
  storeId: [{ type: 'required', message: Messages.STORE_NAME_REQUIRED }],
  coverImage: [{ type: 'required', message: Messages.BILL_REQUIRED }],
  invoice_date: [{ type: 'required', message: Messages.INVOICE_DATE }],
};
export const userValidationRules = {
  phone: [
    { type: 'required', message: Messages.CONTACT_NUMBER_REQUIRED },
    {
      type: 'pattern',
      value: /^[0-9]{10}$/,
      message: Messages.CONTACT_NUMBER_VALID,
    },
  ],
  name: [
    { type: 'required', message: Messages.NAME_REQUIRED },
    { type: 'alphaSpace', message: Messages.ALPHABET_SPACE },
  ],
  email: [
    { type: 'required', message: Messages.EMAIL_REQUIRED },
    {
      type: 'optionalPattern',
      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: Messages.EMAIL_INVALID,
    },
  ],
};

export const permissionValidationRules = {
  mallId: [{ type: 'required', message: Messages.MALL_NAME_REQUIRED }],
  roleId: [{ type: 'required', message: Messages.ROLE_REQUIRED }],
};

export const feedbackValidationRules = {
  title: [{ type: 'required', message: Messages.FEEDBACK_NAME_REQUIRED }],
  image: [{ type: 'required', message: Messages.FEEDBACK_IMAGE_REQUIRED }],
  description: [{ type: 'required', message: Messages.DESCRIPTION_REQUIRED }],
  headline: [{ type: 'required', message: Messages.HEADLINE_REQUIRED }],
  docUrl: [
    { type: 'required', message: Messages.URL_REQUIRED },
    {
      type: 'optionalPattern',
      value:
        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/,
      message: Messages.INVALID_URL,
    },
  ],
  startDate: [
    { type: 'required', message: Messages.START_DATE_REQUIRED },

    {
      type: 'dateNotGreaterThan',
      startDateField: 'startDate',
      endDateField: 'expiredDate',
      message: 'Start date must not be greater than end date',
    },
  ],
  expiredDate: [{ type: 'required', message: Messages.END_DATE_REQUIRED }],
};

export const campaignValidationRules = {
  name: [{ type: 'required', message: 'Campaign Name is required' }],
  gameType: [{ type: 'required', message: 'Game Type is required' }],
  triggerType: [{ type: 'required', message: 'Trigger Type is required' }],
  // startDate/endDate are optional (nullable server-side, Phase 9 SC-2) — no
  // `required` rule. The ordering check still applies when both are set.
  startDate: [],
  endDate: [
    {
      type: 'endDateNotBeforeStartDate',
      startDateField: 'startDate',
      endDateField: 'endDate',
      message: 'End date cannot be before start date',
    },
  ],
  // Bill window (billStartDate/billEndDate) — the separate date pair
  // deciding which invoice dates count, independent of the campaign window
  // above (Phase 9). Also optional client-side; the server's
  // assertBillDatesRequiredWhenBillReading is the actual boundary requiring
  // both when the campaign reads bills (09-06-SUMMARY.md).
  billStartDate: [],
  billEndDate: [
    {
      type: 'endDateNotBeforeStartDate',
      startDateField: 'billStartDate',
      endDateField: 'billEndDate',
      message: 'Bill end date cannot be before bill start date',
    },
  ],
  // Bonus points are optional (a campaign can be vouchers-only). When either
  // field is set they must satisfy the same rules the backend enforces in
  // GamificationCampaignService.assertPointsConfigValid: budget >= 0,
  // pointsPerWin >= 1, both required together, and pointsPerWin must not
  // exceed the whole budget. No campaign dates are read — see the pointsConfig
  // handler for why the per-day ceiling that used to live here is gone.
  totalPointsBudget: [
    {
      type: 'pointsConfig',
      budgetField: 'totalPointsBudget',
      perWinField: 'pointsPerWin',
    },
  ],
  // singleDaySpendMin/Max are both optional per D-01 — no `required` rule.
  // The backend only asserts @IsNumber on this pair, so a NEGATIVE spend
  // threshold was accepted by both layers; a spend floor below zero is
  // meaningless (every bill clears it). nonNegative is listed BEFORE
  // rangeComparison on the max so a negative max reports the plain
  // "0 or greater" rather than the less obvious ordering message.
  singleDaySpendMin: [
    {
      type: 'nonNegative',
      message: 'Minimum Amount must be 0 or greater',
    },
  ],
  singleDaySpendMax: [
    {
      type: 'nonNegative',
      message: 'Max amount must be 0 or greater',
    },
    {
      type: 'rangeComparison',
      minField: 'singleDaySpendMin',
      maxField: 'singleDaySpendMax',
      message: 'Max amount must be greater than min amount',
    },
  ],
};

// Quick task 260922-mmg (Force App Update). Mirrors
// AppSettingsService.ts's parseAppSettingsInput exactly — the server is
// authoritative; these rules are client-side UX only. Build's range check
// (1..2147483647) is NOT expressible with `optionalPattern` alone (the
// regex only rules out non-positive-integer shapes) and is added on top in
// useAppSettings.js's validateAppSettings.
export const appSettingsValidationRules = {
  android_minimum_version: [
    {
      type: 'optionalPattern',
      value: /^v?\d+(\.\d+)*(-[0-9A-Za-z.-]+)?$/,
      message:
        'Android minimum version must look like 2.1.5 (numbers separated by dots, optional leading v and -suffix)',
    },
    {
      type: 'maxLength',
      value: 32,
      message: 'Android minimum version must be 32 characters or fewer',
    },
  ],
  android_minimum_build: [
    {
      type: 'optionalPattern',
      value: /^[1-9]\d*$/,
      message: 'Android minimum build must be a whole number from 1 to 2147483647',
    },
  ],
  ios_minimum_version: [
    {
      type: 'optionalPattern',
      value: /^v?\d+(\.\d+)*(-[0-9A-Za-z.-]+)?$/,
      message:
        'iOS minimum version must look like 2.1.5 (numbers separated by dots, optional leading v and -suffix)',
    },
    {
      type: 'maxLength',
      value: 32,
      message: 'iOS minimum version must be 32 characters or fewer',
    },
  ],
  ios_minimum_build: [
    {
      type: 'optionalPattern',
      value: /^[1-9]\d*$/,
      message: 'iOS minimum build must be a whole number from 1 to 2147483647',
    },
  ],
  title: [{ type: 'maxLength', value: 255, message: 'Title must be 255 characters or fewer' }],
  message: [
    { type: 'maxLength', value: 1000, message: 'Message must be 1000 characters or fewer' },
  ],
  button_text: [
    { type: 'maxLength', value: 255, message: 'Button text must be 255 characters or fewer' },
  ],
};

// utils/validation.js
export const validate = (values, rules) => {
  const errors = {};

  for (const field in rules) {
    if (rules.hasOwnProperty(field)) {
      const value = values[field];
      const fieldRules = rules[field];

      for (const rule of fieldRules) {
        if (rule.type === 'required' && (!value || (Array.isArray(value) && value.length === 0))) {
          errors[field] = rule.message || 'This field is required';
          break;
        }

        // Like `required`, but treats a present value of 0 (or '0') as valid.
        // Use for numeric fields where 0 is a legitimate value (e.g. loyalty
        // points) — the plain `required` rule's `!value` check misfires on
        // numeric 0 (`!0` is true). Still rejects '', null/undefined, NaN, [].
        if (rule.type === 'requiredAllowZero') {
          const isEmpty =
            value === null ||
            value === undefined ||
            value === '' ||
            (typeof value === 'number' && Number.isNaN(value)) ||
            (Array.isArray(value) && value.length === 0);
          if (isEmpty) {
            errors[field] = rule.message || 'This field is required';
            break;
          }
        }

        if (rule.type === 'minLength' && value.length < rule.value) {
          errors[field] = rule.message || `Minimum length is ${rule.value}`;
          break;
        }

        if (rule.type === 'maxLength' && value.length > rule.value) {
          errors[field] = rule.message || `Maximum length is ${rule.value}`;
          break;
        }

        if (rule.type === 'pattern' || rule.type === 'optionalPattern') {
          if (value) {
            const isPatternMatched = fieldRules
              .filter(
                (r) => r.type === 'pattern' || r.type === 'optionalPattern'
              )
              .some((r) => r.value.test(value));

            if (!isPatternMatched) {
              errors[field] = rule.message || 'Invalid format';
              break;
            }
          }
        }

        // Custom rule for date comparison
        if (rule.type === 'dateNotGreaterThan') {
          const startDate = new Date(values[rule.startDateField]);
          const endDate = new Date(values[rule.endDateField]);
          if (startDate > endDate) {
            errors[rule.startDateField] =
              rule.message || 'Start date must not be greater than end date';
            break;
          }
        }
        // Inclusive variant of dateNotGreaterThan: allows equal start/end dates
        // (single-day campaigns), only rejects endDate strictly before startDate.
        // Errors are keyed on the END date field, not the start field.
        if (rule.type === 'endDateNotBeforeStartDate') {
          const startDate = new Date(values[rule.startDateField]);
          const endDate = new Date(values[rule.endDateField]);
          if (endDate < startDate) {
            errors[rule.endDateField] =
              rule.message || 'End date cannot be before start date';
            break;
          }
        }
        if (rule.type === 'timeNotGreaterThan') {
          const startTime = new Date(
            `1970-01-01T${values[rule.startTimeField]}:00`
          );
          const endTime = new Date(
            `1970-01-01T${values[rule.endTimeField]}:00`
          );
          if (startTime > endTime) {
            errors[rule.startTimeField] =
              rule.message || 'Start time must not be greater than end time';
            break;
          }
        }
        if (rule.type === 'alphaSpace') {
          const alphaSpacePattern = /^[A-Za-z\s]+$/;
          if (!alphaSpacePattern.test(value)) {
            errors[field] =
              rule.message || 'Only alphabets and spaces are allowed';
            break;
          }
        }
        // New rule for range validation. Explicitly skip an
        // empty/null/undefined value — a range field is always optional —
        // and reject non-integers (e.g. '50.5') on the client instead of
        // relying on JS coercion accidents or the backend's @IsInt to
        // catch it.
        if (rule.type === 'range') {
          if (value === '' || value === null || value === undefined) {
            break;
          }
          if (!Number.isInteger(Number(value))) {
            errors[field] =
              rule.message ||
              `Value must be between ${rule.min} and ${rule.max}`;
            break;
          }
          if (value < rule.min || value > rule.max) {
            errors[field] =
              rule.message ||
              `Value must be between ${rule.min} and ${rule.max}`;
            break;
          }
        }

        // New rule for range comparison
        if (rule.type === 'rangeComparison') {
          const minValue = values[rule.minField];
          const maxValue = values[rule.maxField];
          if (minValue && maxValue) {
            const minNum = Number(minValue);
            const maxNum = Number(maxValue);
            if (
              !Number.isNaN(minNum) &&
              !Number.isNaN(maxNum) &&
              minNum >= maxNum
            ) {
              errors[field] =
                rule.message || 'Max range must be greater than min range';
              break;
            }
          }
        }
        // Optional numeric field that may not be negative. Blank/absent is
        // always allowed — these fields are optional; this rule only
        // constrains the value when one is actually present.
        if (rule.type === 'nonNegative') {
          const raw = values[field];
          const isBlank = raw === '' || raw === null || raw === undefined;
          if (!isBlank) {
            const num = Number(raw);
            if (!Number.isNaN(num) && num < 0) {
              errors[field] = rule.message || 'Must be 0 or greater';
              break;
            }
          }
        }

        // Bonus-points cross-field validation — mirrors the backend
        // GamificationCampaignService.assertPointsConfigValid so the admin sees
        // the same rules before submit. Both fields optional (vouchers-only),
        // but if either is set they must be consistent.
        if (rule.type === 'pointsConfig') {
          const budgetRaw = values[rule.budgetField];
          const perWinRaw = values[rule.perWinField];
          const isSet = (v) => v !== '' && v !== null && v !== undefined;
          const hasBudget = isSet(budgetRaw);
          const hasPerWin = isSet(perWinRaw);

          if (hasBudget || hasPerWin) {
            const budget = Number(budgetRaw);
            const perWin = Number(perWinRaw);

            if (hasBudget && (Number.isNaN(budget) || budget < 0)) {
              errors[rule.budgetField] =
                'Total Points Budget must be 0 or greater';
              break;
            }
            // Mirrors the backend's @IsInt on totalPointsBudget. Without it a
            // decimal reached the server and came back as a raw 400 with no
            // field attached.
            if (hasBudget && !Number.isInteger(budget)) {
              errors[rule.budgetField] =
                'Total Points Budget must be a whole number';
              break;
            }
            if (hasBudget && budget > 0 && !hasPerWin) {
              errors[rule.perWinField] =
                'Points Per Win is required when a points budget is set';
              break;
            }
            if (hasPerWin && (Number.isNaN(perWin) || perWin < 1)) {
              errors[rule.perWinField] = 'Points Per Win must be at least 1';
              break;
            }
            // Mirrors the backend's @IsInt on pointsPerWin.
            if (hasPerWin && !Number.isInteger(perWin)) {
              errors[rule.perWinField] = 'Points Per Win must be a whole number';
              break;
            }
            if (hasPerWin && !(hasBudget && budget > 0)) {
              errors[rule.budgetField] =
                'Total Points Budget must be greater than 0 when Points Per Win is set';
              break;
            }
            if (hasBudget && budget > 0 && hasPerWin && !Number.isNaN(perWin)) {
              // The ONLY ceiling on Points Per Win, and date-independent. A
              // single win can never cost more than the entire campaign
              // budget — at perWin > budget the points fallback can never fire
              // even once, so the campaign silently rewards nobody.
              //
              // A stricter per-day ceiling used to follow this one:
              // perWin <= budget / campaignDays. It mirrored the backend, but
              // the backend rule was written for the schedule model that
              // spread a prize pool across the campaign window — retired in BE
              // quick task 260818-o5h, which left the validation behind. It
              // was rejecting configs the engine runs happily (2000 budget /
              // 500 per win over 33 days came back as "only 60 a day", when
              // the engine just affords floor(2000 / 500) = 4 wins for the
              // whole campaign, capped per pool by winsPerDay). Removed from
              // the backend and mirrored away here.
              if (perWin > budget) {
                errors[rule.perWinField] =
                  `Points Per Win (${perWin}) must not exceed the ` +
                  `Total Points Budget (${budget})`;
                break;
              }
            }
          }
        }

        if (values.notification_type === 'whatsapp' && !values.campaign) {
          errors.campaign = 'Campaign is required';
        }

        // Add more validation rules as needed
      }
    }
  }

  return errors;
};
